module.exports = __webpack_public_path__ + "img/peoplepp.884ec1a4.jpg";